import type { AuthenticatedUser } from "../../api/auth";
import type { LaunchpadTile } from "../../components/Launchpad";
import { CheckinPage } from "./CheckinPage";
import { HoflistePage } from "./HoflistePage";
import { UserManagementPage } from "../../components/UserManagement/UserManagementPage";
import { TenantContainer } from "../TenantContainer";

const TENANT_ROUTES = [
  { path: "/checkin", element: <CheckinPage /> },
  { path: "/hofliste", element: <HoflistePage /> },
  { path: "/users", element: <UserManagementPage /> }
];

interface TenantRootProps {
  currentUser?: AuthenticatedUser;
}

export function TenantRoot({ currentUser }: TenantRootProps) {
  return (
    <TenantContainer
      tiles={[]}
      routes={TENANT_ROUTES}
      currentUser={currentUser}
    />
  );
}
